import { isEqual } from "lodash";
import { useState } from "react";

import { LegalEntityPasswordStatusQuickFilter } from "./interfaces";

export const useLegalEntityPasswordStatusQuickFilter = () => {
  const [quickFilter, setQuickFilter] = useState<LegalEntityPasswordStatusQuickFilter>({
    lePasswordStatus: {},
  });

  const handleChangeQuickFilter = (
    filter: keyof LegalEntityPasswordStatusQuickFilter,
    value: LegalEntityPasswordStatusQuickFilter["lePasswordStatus"]
  ) => {
    if (isEqual(value, quickFilter[filter])) return;

    setQuickFilter((state) => ({ ...state, [filter]: value }));
  };

  return {
    legalEntityPasswordStatusQuickFilter: quickFilter,
    setLegalEntityPasswordStatusQuickFilter: handleChangeQuickFilter,
  };
};
